import _ from 'lodash';
import { user } from './user';

export const applicationMap: { [k: string]: any } = {
  // legacy portals
  INTERNAL: {
    applicationId: 'INTERNAL',
    name: 'Manager Portal',
    mainNavTitleKey: 'PTX',
    title: 'MioTech - Manager Portal',
  },

  // home page
  USER: {
    applicationId: 'USER',
    name: 'Home',
    mainNavTitleKey: 'USER',
    title: 'MioTech | Home',
  },

  // applications
  ADM: {
    applicationId: 'ADM',
    name: 'Super Admin',
    mainNavTitleKey: 'ADM',
    title: 'MioTech | Super Admin',
    icon: 'icon-permission',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-super-admin-dark-48x48.svg',
  },
  CRM: {
    applicationId: 'CRM',
    name: 'CRM',
    mainNavTitleKey: 'CRM',
    title: 'MioTech | CRM',
    icon: 'icon-clients',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-crm-dark-48x48.svg',
  },
  RED: {
    applicationId: 'RED',
    name: 'Portfolio',
    mainNavTitleKey: 'RED',
    title: 'MioTech | PortX',
    icon: 'icon-port-x',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-port-x-dark-48x48.svg',
  },
  AMI: {
    applicationId: 'AMI',
    name: 'AMI',
    mainNavTitleKey: 'AMI',
    title: 'MioTech | AMI',
    icon: 'icon-ami',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-ami-dark-48x48.svg',
  },
  AMI2: {
    applicationId: 'AMI2',
    name: 'AMI',
    mainNavTitleKey: 'AMI',
    title: 'MioTech | AMI',
    icon: 'icon-ami',
  },
  TXN: {
    applicationId: 'TXN',
    name: 'Transaction',
    mainNavTitleKey: 'TXN',
    title: 'MioTech | Transaction',
    icon: 'icon-transaction',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-transaction-dark-48x48.svg',
  },
  WKF: {
    applicationId: 'WKF',
    name: 'Workflow',
    mainNavTitleKey: 'WKF',
    title: 'MioTech | Workflow',
    icon: 'icon-workflow',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-workflow-dark-48x48.svg',
  },
  CMU: {
    applicationId: 'CMU',
    name: 'Communication',
    mainNavTitleKey: 'CMU',
    title: 'MioTech | Communication',
    icon: 'icon-message',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-communication-dark-48x48.svg',
  },
  PTX: {
    applicationId: 'PTX',
    name: 'PortX',
    mainNavTitleKey: 'PTX',
    title: 'MioTech | PortX',
    icon: 'icon-port-x',
    largeIconUrl:
      'https://static.miotech.com/images/icons/applications-port-x-dark-48x48.svg',
  },
  PRD: {
    applicationId: 'PRD',
    name: 'Product',
    mainNavTitleKey: 'PRD',
    title: 'MioTech | Product',
  },
  WLN: {
    applicationId: 'WLN',
    name: 'WealthLINK',
    mainNavTitleKey: 'WLN',
    icon: 'icon-wln',
    title: 'MioTech | WealthLINK',
    largeIconUrl:
      'https://static.miotech.com/images/icons/application-wealthlink-square-48x48.svg',
  },

  // To be removed
  ANALYSIS: {
    applicationId: 'ANALYSIS',
    name: 'Port X',
    mainNavTitleKey: 'PTX',
    title: 'MioTech | Portfolio',
    icon: 'icon-portfolio',
  },
  NOTIFICATION: {
    applicationId: 'NOTIFICATION',
    name: 'Notification',
    mainNavTitleKey: 'NOTIFICATION',
    title: 'MioTech | Notification',
  },

  // for testing
  SHARED: {
    applicationId: 'SHARED',
    name: 'Shared Library',
    mainNavTitleKey: 'SHARED',
    title: 'MioTech | Shared Library',
  },

  OPENAPI: {
    applicationId: 'OPENAPI',
    name: 'MioAPI',
    mainNavTitleKey: 'OPENAPI',
    title: 'MioTech | MioAPI',
  },

  SPREADI: {
    applicationId: 'SPREADI',
    name: 'Spreadi',
    mainNavTitleKey: 'SPREADI',
    title: 'MioTech | Spreadi',
  },

  MDA: {
    applicationId: 'MDA',
    name: 'MDA',
    mainNavTitleKey: 'MDA',
    title: 'MioTech | MDA',
  },

  CSR_RECORD: {
    applicationId: 'CSR_RECORD',
    name: 'CSR',
    mainNavTitleKey: 'CSR',
    title: 'MioTech | CSR',
  },

  ESG_HUB: {
    applicationId: 'ESG_HUB',
    name: 'ESG_HUB',
    mainNavTitleKey: 'ESG_HUB',
    title: 'MioTech | ESG_HUB',
  },

  CARBON_LENS: {
    applicationId: 'CARBON_LENS',
    name: 'CARBON_LENS',
    mainNavTitleKey: 'CARBON_LENS',
    title: 'MioTech | CARBON_LENS',
  },

  EHS: {
    applicationId: 'EHS',
    name: 'ESGhub',
    mainNavTitleKey: 'EHS',
    title: 'ESGhub',
  },

  GVI: {
    applicationId: 'GVI',
    name: 'GVI',
    mainNavTitleKey: 'GVI',
    title: 'GVI'
  }
};

export const applications = [
  applicationMap.ADM,
  applicationMap.RED,
  applicationMap.TXN,
  applicationMap.AMI,
  applicationMap.CRM,
  applicationMap.WKF,
  applicationMap.WLN,
  applicationMap.SPREADI,
  applicationMap.ESG_HUB,
  applicationMap.MDA,
  applicationMap.CSR_RECORD,
  applicationMap.CARBON_LENS,
  applicationMap.EHS,
  applicationMap.GVI
];

export const allApplications = [
  applicationMap.ADM,
  applicationMap.RED,
  applicationMap.TXN,
  applicationMap.AMI,
  applicationMap.CRM,
  applicationMap.WKF,
  applicationMap.WLN,
  applicationMap.CMU,
  applicationMap.SPREADI,
  applicationMap.ESG_HUB,
  applicationMap.MDA,
  applicationMap.CSR_RECORD,
  applicationMap.CARBON_LENS,
  applicationMap.EHS,
  applicationMap.GVI
];

// populate host property from applicationHostMap
// 这段代码已经不再使用，废弃了
// const { host } = window.__config__;
// const hostNameMap: { [k: string]: string } = {
//   USER: `${host}/home`,
//   INTERNAL: `${host}/internal`,

//   WKF: `${host}/workflow`,
//   RED: `${host}/portfolio`,
//   TXN: `${host}/transaction`,
//   ADM: `${host}/super-admin`,
//   CMU: `${host}/communication`,
//   AMI: `${host}/ami`,
//   PRD: `${host}/product`,
//   CRM: `${host}/crm`,
//   WLN: `${host}/wealth`,

//   AMI2: `${host}/internal/knowledge`,
//   ANALYSIS: `${host}/internal/analysis`,
//   NOTIFICATION: `${host}/internal/notification`,

//   SHARED: `${host}/shared`,
//   OPENAPI: `${host}/open-api`,
//   SPREADI: `${host}/spreadi`,
//   ESG_HUB: `${host}/esg-hub`,

//   MDA: `${host}/mda`,
//   CSR_RECORD: `${host}/csr`,
//   CARBON_LENS: `carbon-lens.${host}`,
// };

const pathMap: { [k: string]: string } = {
  USER: '/home',
  INTERNAL: '/internal',

  WKF: '/workflow',
  RED: '/portfolio',
  TXN: '/transaction',
  ADM: '/super-admin',
  CMU: '/communication',
  AMI: '/ami',
  PRD: '/product',
  CRM: '/crm',
  WLN: '/wealth',

  AMI2: '/internal/knowledge',
  ANALYSIS: '/internal/analysis',
  NOTIFICATION: '/internal/notification',

  SHARED: '/shared',
  OPENAPI: '/open-api',
  SPREADI: '/spreadi',
  ESG_HUB: '/esg-hub',
  EHS: '/hub',

  MDA: '/mda',
  CSR_RECORD: '/csr',
  CARBON_LENS: '/carbon-lens',// nginx那边处理，302跳转

  GVI: '/gvi'
};

_.each(applicationMap, application => {
  // application.host = hostNameMap[application.applicationId];
  application.path = pathMap[application.applicationId];
});

export const currentApplication =
  applicationMap[(window as any).applicationId];

// eslint-disable-next-line eqeqeq
if (currentApplication?.title != undefined) {
  document.title = currentApplication.title;
}

export function getHostNameByApplicationId(applicationId: string) {
  let saasHost;
  if (applicationId === 'USER') {
    saasHost = (user.appHostMap || {}).USER;
  } else if (applicationId === 'AMI') {
    saasHost = (user.appHostMap || {}).AMI;
  } else if (applicationId === 'CARBON_LENS') {
    saasHost = (user.appHostMap || {}).CARBON_LENS;
  } else {
    saasHost = (user.appHostMap || {}).PORTX;
  }
  if (!saasHost) {
    saasHost = window.__config__.host;
  }
  return `${saasHost}${applicationMap[applicationId].path}`;
}

export function redirectToApplication(
  applicationId: string,
  path = '',
  query: any = '',
) {
  if (!applicationMap[applicationId]) {
    // eslint-disable-next-line
    alert(
      `Cannot redirect to Application ${applicationId}. Please contact your system administrator.`,
    );
    return;
  }

  let url = getHostNameByApplicationId(applicationId);

  if (path && path.length) {
    if (path[0] !== '/') {
      url = `${url}/`;
    }
    url = `${url}${path}`;
  }

  if (typeof query === 'string' && query.length) {
    if (query[0] !== '?') {
      url = `${url}?`;
    }
    url = `${url}${query}`;
  }

  if (typeof query === 'object' && query !== {}) {
    if (query[0] !== '?') {
      url = `${url}?`;
    }
    const queryString = _.map(query, (value, key) => `${key}=${value}`).join(
      '&',
    );
    url = `${url}${queryString}`;
  }

  window.location.href = url;
}

export function getUrlToApplication(
  applicationId: string,
  path = '',
  query = '',
) {
  if (!applicationMap[applicationId]) {
    // eslint-disable-next-line
    console.error(
      `Cannot redirect to Application ${applicationId}. Please contact your system administrator.`,
    );
    return '';
  }

  let url = getHostNameByApplicationId(applicationId);

  if (path && path.length) {
    if (path[0] !== '/') {
      url = `${url}/`;
    }
    url = `${url}${path}`;
  }

  if (typeof query === 'string' && query.length) {
    if (query[0] !== '?') {
      url = `${url}?`;
    }
    url = `${url}${query}`;
  }

  if (typeof query === 'object' && query !== {}) {
    if (query[0] !== '?') {
      url = `${url}?`;
    }
    const queryString = _.map(query, (value, key) => `${key}=${value}`).join(
      '&',
    );
    url = `${url}${queryString}`;
  }

  return url;
}
